import styled, { css } from 'styled-components'

import { Colors } from 'common-constants/colors'
import { breakPointSizeBig } from 'components/page/ForeignProfile/ForeignProfile.constants'
import { GiftTooltipContainerCss } from 'components/page/UserProfile/UserProfileGifts/GiftTooltipContainer'
import { desktopModalPaddingSize, media } from 'components/presentational'
import { RouterLink } from 'components/presentational/link'

export const Gradient = css`
  min-height: 100%;
  min-width: 40px;
  max-width: 40px;
  background-image: linear-gradient(
    to right,
    var(--static-white),
    rgba(var(--static-white-rgb), 0.94) 10%,
    rgba(var(--static-white-rgb), 0) 50%
  );

  ${media.tablet`
    display: none;
  `}
`

export const Mask = css`
  position: absolute;
  top: 0;
  bottom: 0;
  content: '';
  z-index: 1;
  ${Gradient}

  ${media.tablet`
    display: none;
  `}
`

export const Wrapper = styled(RouterLink)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  min-height: 100%;
  position: relative;
  z-index: 1;

  &::after {
    ${Mask};
    ${(props) => props.theme.right}: 0;

    transform: rotate(
      ${(props) => (props.theme.multiplier === 1 ? 180 : 0)}deg
    );
  }

  &::before {
    ${Mask};
    ${(props) => props.theme.left}: 0;

    transform: rotate(
      ${(props) => (props.theme.multiplier === 1 ? 0 : 180)}deg
    );
  }
`

export const WrapperCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  cursor: pointer;
  padding: 0 20px;
  text-align: center;

  ${media.tablet`
    padding: 0;
  `}
`

export const Text = styled.div`
  position: relative;
  font-size: 21px;
`

export const Note = styled.div`
  margin-top: 5px;
  font-size: 16px;
  color: ${Colors.dark};
`

export const WrapperGiftsEmpty = styled.div`
  display: flex;
  align-items: center;
  height: 124px;
  position: relative;
  margin-top: 40px;
  margin-bottom: 30px;

  ${media.tablet`
    margin: 40px -10px 30px -10px
  `}
`

const PlaceHolderImage = css`
  display: flex;
  width: 60px;
  flex-shrink: 0;
  overflow: hidden;

  @media (max-width: ${breakPointSizeBig}px) {
    width: 44px;
  }

  ${media.tablet`
    width: 55px;
  `}
`

export const LeftImage = styled.div`
  ${PlaceHolderImage};
  justify-content: flex-end;
`

export const RightImage = styled.div`
  ${PlaceHolderImage};
  justify-content: flex-start;
`

export const ImagePlaceHolder = styled.img`
  height: 120px;
  min-width: 120px;

  @media (max-width: ${breakPointSizeBig}px) {
    height: 88px;
    min-width: 88px;
  }

  ${media.tablet`
    height: 120px;
    min-width: 120px; 
  `}
`

export const WrapperGiftMask = styled.div`
  display: flex;
  margin-bottom: 20px;
  overflow: hidden;

  & div[data-name='arrow-left'],
  & div[data-name='arrow-right'] {
    padding: 0;
    z-index: 1;
  }

  &:hover div[data-name='arrow-left'],
  &:hover div[data-name='arrow-right'] {
    opacity: 1;
  }
`

export const LeftGradient = styled.div`
  ${Gradient};
  transform: rotate(${(props) => (props.theme.multiplier === 1 ? 0 : 180)}deg);
`

export const RightGradient = styled.div`
  ${Gradient};
  transform: rotate(${(props) => (props.theme.multiplier === 1 ? 180 : 0)}deg);
`

export const WrapperGiftsWithLink = styled.div`
  position: relative;
  margin: 40px 0 30px;

  ${media.tablet`
    margin: 40px -10px 30px;
  `}
`

export const WrapperRelative = styled.div`
  position: relative;
`

export const GiftsScrollBlock = styled.div`
  display: flex;
  overflow: hidden; /* чтобы не было scrollBar на window */
  margin: 0 -${desktopModalPaddingSize}px;
  width: 100%;
  text-align: left;

  ${media.tablet`
     margin: 0;
  `};

  @media (hover: none) {
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
  }
`

export const GiftItemCss = css`
  min-width: 40%;
  max-width: 40%;
  scroll-snap-align: center;
  box-sizing: border-box;

  /* скрываем для всех ios Safari < 13, там есть какие то проблемы. */

  /* TODO: надо посмотреть что там за проблемы. */
  @media screen and (-webkit-device-pixel-ratio: 0) {
    scroll-snap-align: none;
  }

  /* открываем только для тех кто выше 13 версии. */

  /* Фигня если честно полная. но scroll-snap-align не работает без webkit-overflow-scrolling, */

  /* А добавление webkit-overflow-scrolling ломает tooltip при наведение. поэтому вот так. */

  /* как только у нас не будет 11 и 12 версии можно будет убрать. В 13 и выше по умолчанию включено webkit-overflow-scrolling и все хорошо */
  @supports (line-break: anywhere) {
    scroll-snap-align: center;
  }

  ${media.tablet`
    min-width: 22%;
    max-width: 22%;
    padding: 10px;
  `}

  ${media.phone`
    min-width: 40%;
    max-width: 40%;
    padding: 10px;
  `}
`

export const GiftItem = styled.div`
  ${GiftItemCss};
  padding: 10px;

  &:hover div[data-tooltip='gift-tooltip'] {
    display: block;
  }
`

export const VipGiftTooltipContainer = styled.div`
  ${GiftTooltipContainerCss};

  ${(props) => props.theme.left}: 150px;

  ${media.tablet`
     ${(props) => props.theme.left}: 140px;
  `}
`

export const GiftItemVip = styled.div<{
  imageAvatar?: boolean
}>`
  ${GiftItemCss};
  padding: 20px;

  ${VipGiftTooltipContainer} {
    visibility: visible;
    opacity: 0;
    z-index: -1;
    transition: opacity 0.3s ease-in-out;
  }

  &:hover {
    ${VipGiftTooltipContainer} {
      opacity: 1;
      z-index: 4;
    }
  }
`

export const Img = styled.img`
  height: 100%;
  width: 100%;
`

export const WrapperLink = styled(RouterLink)`
  display: flex;
  padding: 0 30px;

  @media (max-width: 360px) {
    padding: 0 36px;
  }
`
